// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Ezq3n","productName":"Table_productName__2QF1L"};